(function(themeAddresses) {

  /**
     * Currency Helpers
     * -----------------------------------------------------------------------------
     * A collection of useful functions that help with currency formatting
     *
     * Current contents
     * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
     *
     */

    const moneyFormat = '${{amount}}';

    /**
     * Format money values based on your shop currency settings
     * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
     * or 3.00 dollars
     * @param  {String} format - shop money_format setting
     * @return {String} value - formatted value
     */
    function formatMoney(cents, format) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
        if (isNaN(number) || number == null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        const parts = number.split('.');
        const dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
        const centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_with_period_and_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', '.');
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }

  const throttle = (fn, wait) => {
      let prev, next;
      return function invokeFn(...args) {
        const now = Date.now();
        next = clearTimeout(next);
        if (!prev || now - prev >= wait) {
          // eslint-disable-next-line prefer-spread
          fn.apply(null, args);
          prev = now;
        } else {
          next = setTimeout(invokeFn.bind(null, ...args), wait - (now - prev));
        }
      };
    };

    function FetchError(object) {
      this.status = object.status || null;
      this.headers = object.headers || null;
      this.json = object.json || null;
      this.body = object.body || null;
    }
    FetchError.prototype = Error.prototype;

  const getUrlString = (params, keys = [], isArray = false) => {
      const p = Object.keys(params)
        .map((key) => {
          let val = params[key];

          if ('[object Object]' === Object.prototype.toString.call(val) || Array.isArray(val)) {
            if (Array.isArray(params)) {
              keys.push('');
            } else {
              keys.push(key);
            }
            return getUrlString(val, keys, Array.isArray(val));
          } else {
            let tKey = key;

            if (keys.length > 0) {
              const tKeys = isArray ? keys : [...keys, key];
              tKey = tKeys.reduce((str, k) => {
                return '' === str ? k : `${str}[${k}]`;
              }, '');
            }
            if (isArray) {
              return `${tKey}[]=${val}`;
            } else {
              return `${tKey}=${val}`;
            }
          }
        })
        .join('&');

      keys.pop();
      return p;
    };

  function saveShippingDataToLocalStorage(province, fullProvinceName, zip){
    const expirationTimeMillis = Date.now() + 30 * 24 * 60 * 60 * 1000;
    const data = {
      value: { province, fullProvinceName, zip },
      expirationTimeMillis,
    };
    localStorage.setItem('is_shipping_data', JSON.stringify(data));
    
  }

  function getShippingDataFromLocalStorage(){
    try{
      const raw = localStorage.getItem('is_shipping_data');
      if(!raw) return null;

      const parsed = JSON.parse(raw);

      if(Date.now() > parsed.expirationTimeMillis){
        localStorage.removeItem('is_shipping_data');
        return null;
      }

      return parsed.value;
    }catch(e){
      console.warn('Failed to parse shipping data: ', e);
      return null;
    }
  }

  function getCartInfo(){
    return fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      return {
        items: cart.items,
        total_price: cart.total_price, //in cents
        total_price_formatted: (cart.total_price / 100).toFixed(2), //in dollars
        total_quantity: cart.item_count
      };
    })
    .catch(error => {
      console.error('Error fetching cart info: ', error);
      return{
        items: [],
        total_price: 0,
        total_price_formatted: '0.00',
        total_quantity: 0
      }
    });
  }

  let shippingDiscountData = [];
  fetch(window.shippingDiscountDataUrl)
    .then(res => res.json())
    .then(data => {
      shippingDiscountData = data;
    })
    .catch(err => {
      console.warn('Failed to load shippng discount data: ', err);
    });

  
  
  const selectors$P = {
      templateNoShipping: '[data-template-no-shipping]',
      getRates: '.get-rates',
      addressContainer: '#address_container',
      addressCountry: '#address_country',
      addressProvince: '#address_province',
      addressZip: '#address_zip',
      wrapper: '#wrapper-response',
      template: '#shipping-calculator-response-template',
    };

    const attributes$s = {
      templateNoShipping: 'data-template-no-shipping',
      default: 'data-default',
    };

    const classes$D = {
      hidden: 'is-hidden',
      error: 'error',
      center: 'center',
      success: 'success',
      disabled: 'disabled',
      getRatesTrigger: 'get-rates--trigger',
    };

    const texts = {
      error: 'Error : country is not supported.',
      feedback: 'We do not ship to this destination.',
      feedbackLabel: 'Error : ',
    };

    class IsShippingCalculator extends HTMLElement {
      constructor() {
        super();

        this.getRatesButton = this.querySelector(selectors$P.getRates);
        this.fieldsContainer = this.querySelector(selectors$P.addressContainer);
        this.selectCountry = this.querySelector(selectors$P.addressCountry);
        this.selectProvince = this.querySelector(selectors$P.addressProvince);
        this.template = this.querySelector(selectors$P.template);
        this.wrapper = this.querySelector(selectors$P.wrapper);
        this.onCountryChangeEvent = () => this.onCountryChange();
        this.onButtonClickEvent = () => this.onButtonClick();
      }

      connectedCallback() {
        const htmlEl = document.querySelector('html');
        let locale = 'en';
        if (htmlEl.hasAttribute('lang') && htmlEl.getAttribute('lang') !== '') {
          locale = htmlEl.getAttribute('lang');
        }

        if (this.fieldsContainer) {
          themeAddresses.AddressForm(this.fieldsContainer, locale, {
            shippingCountriesOnly: true,
          });
        }

        const saved = getShippingDataFromLocalStorage();
        if(saved){
          const zipInput = document.querySelector('#address_zip');
          if (zipInput) zipInput.value = saved.zip;

          if (this.selectProvince){
            this.selectProvince.setAttribute('data-default', saved.province);
            this.selectProvince.setAttribute('data-default-fullname', saved.fullProvinceName);
            
          }
          
        }

        if (this.selectCountry && this.selectCountry.hasAttribute(attributes$s.default) && this.selectProvince && this.selectProvince.hasAttribute(attributes$s.default)) {
          this.selectCountry.addEventListener('change', this.onCountryChangeEvent);
        }

        if (this.getRatesButton) {
          this.getRatesButton.addEventListener('click', this.onButtonClickEvent);

          if (theme.settings.customerLoggedIn && this.getRatesButton.classList.contains(classes$D.getRatesTrigger)) {
            const zipElem = document.querySelector(selectors$P.addressZip);
            if (zipElem && zipElem.value) {
              this.getRatesButton.dispatchEvent(new Event('click'));
            }
          }
        }

        const waitForProvinceOptions = () => {
          if(this.selectProvince && this.selectProvince.options.length > 0){
            this.handleInitialRatesLoad();
          }else{
            setTimeout(waitForProvinceOptions, 100);
          }
        };
        waitForProvinceOptions();

        this.onCartChanged = () => {
          
          if (this.selectCountry && this.selectProvince && this.getRatesButton){
            this.handleInitialRatesLoad();
          }
          
        };
        document.addEventListener('theme:cart:change', this.onCartChanged);
      }

      disconnectedCallback() {
        if (this.selectCountry && this.selectCountry.hasAttribute(attributes$s.default) && this.selectProvince && this.selectProvince.hasAttribute(attributes$s.default)) {
          this.selectCountry.removeEventListener('change', this.onCountryChangeEvent);
        }

        if (this.getRatesButton) {
          this.getRatesButton.removeEventListener('click', this.onButtonClickEvent);
        }
        document.removeEventListener('theme:cart:change', this.onCartChanged);
      }

      onCountryChange() {
        this.selectCountry.removeAttribute(attributes$s.default);
        this.selectProvince.removeAttribute(attributes$s.default);
      }

      onButtonClick() {
        this.disableButtons();
        while (this.wrapper.firstChild) this.wrapper.removeChild(this.wrapper.firstChild);
        this.wrapper.classList.add(classes$D.hidden);
        const shippingAddress = {};
        let elemCountryVal = this.selectCountry.value;
        let elemProvinceVal = this.selectProvince.value;

        const elemCountryData = this.selectCountry.getAttribute(attributes$s.default);
        if (elemCountryVal === '' && elemCountryData && elemCountryData !== '') {
          elemCountryVal = elemCountryData;
        }

        const elemProvinceData = this.selectProvince.getAttribute(attributes$s.default);
        if (elemProvinceVal === '' && elemProvinceData && elemProvinceData !== '') {
          elemProvinceVal = elemProvinceData;
        }

        shippingAddress.zip = document.querySelector(selectors$P.addressZip).value || '';
        shippingAddress.country = elemCountryVal || '';
        shippingAddress.province = elemProvinceVal || '';

        this.getCartShippingRatesForDestination(shippingAddress);
      }

      // Trigger when page load and cart quantity change

       handleInitialRatesLoad() {
        const wrapper = document.querySelector('#shipping-form-wrapper');
        const form1 = document.querySelector('#is-shipping-calculator');
      
        getCartInfo().then(cart => {
          if (cart.total_quantity === 0) {
            // Hide form and clear output when cart is empty
            wrapper?.classList.remove('form-loading');
            if (form1) form1.style.display = 'none';
            this.wrapper.innerHTML = '';
            return;
          }
      
          // Otherwise, continue with shipping lookup
          wrapper?.classList.add('form-loading');
      
          const shippingAddress = {};
          let elemCountryVal = this.selectCountry.value;
          let elemProvinceVal = this.selectProvince.value;
      
          const elemCountryData = this.selectCountry.getAttribute(attributes$s.default);
          if (elemCountryVal === '' && elemCountryData && elemCountryData !== '') {
            elemCountryVal = elemCountryData;
          }
      
          const elemProvinceData = this.selectProvince.getAttribute(attributes$s.default);
          if (elemProvinceVal === '' && elemProvinceData && elemProvinceData !== '') {
            elemProvinceVal = elemProvinceData;
          }
      
          shippingAddress.zip = document.querySelector(selectors$P.addressZip).value || '';
          shippingAddress.country = elemCountryVal || '';
          shippingAddress.province = elemProvinceVal || '';
      
          this.getCartShippingRatesForDestination(shippingAddress);
      
          this.spinnerDoneCallback = () => {
            wrapper?.classList.remove('form-loading');
            if (form1) form1.style.display = 'block';
          };
        });
      }

      formatRate(cents) {
        const price = cents === '0.00' ? window.theme.strings.free : formatMoney(cents, theme.moneyFormat);
        return price;
      }

      // render the response in all conditions i.e button clik, load, cart change

      render(response) {
 
        if (this.template && this.wrapper) {
          this.wrapper.innerHTML = '';
          let ratesList = '';
          let ratesText = '';
          let successClass = `${classes$D.error} ${classes$D.center}`;
          let markup = this.template.innerHTML;
          const rateRegex = /[^[\]]+(?=])/g;

          if (response.rates && response.rates.length) {
            let rateTemplate = rateRegex.exec(markup)[0];

            response.rates.forEach((rate) => {
              let rateHtml = rateTemplate;
              rateHtml = rateHtml.replace(/\|\|rateName\|\|/g, rate.name);
              rateHtml = rateHtml.replace(/\|\|ratePrice\|\|/g, this.formatRate(rate.price));
              ratesList += rateHtml;
            });
          }

          if (response.success) {
            successClass = `${classes$D.success} ${classes$D.center}`;
            const createdNewElem = document.createElement('div');
            createdNewElem.innerHTML = this.template.innerHTML;
            const noShippingElem = createdNewElem.querySelector(selectors$P.templateNoShipping);

            if (response.rates.length < 1 && noShippingElem) {
              ratesText = noShippingElem.getAttribute(attributes$s.templateNoShipping);
            }
          } else {
            ratesText = response.errorFeedback;
          }

          let provinceLine, questionLine, informationLine = '';
          if(response.success && response.province){
            provinceLine = `<p class="is-shipping-calculator_heading">Estimated shipping rates for ${response.province}</p>`;
            questionLine = `<p>Not shipping to ${response.province}?</p>`;
            informationLine = `<p class="is-shipping-calculator_info">Please select the preferred shipping option upon checkout.</p>`;
          }else{
            provinceLine = '';
            questionLine = '';
            informationLine = '';
          }

          let shippingDiscountLine = response.discountLine || '';

          markup = markup.replace(rateRegex, '').replace('[]', '');
          markup = markup.replace(/\|\|ratesList\|\|/g, ratesList);
          markup = markup.replace(/\|\|successClass\|\|/g, successClass);
          markup = markup.replace(/\|\|ratesText\|\|/g, ratesText);
          markup = markup.replace(/\|\|province\|\|/g, provinceLine);
          markup = markup.replace(/\|\|question\|\|/g, questionLine);
          markup = markup.replace(/\|\|information\|\|/g, informationLine);
          markup = markup.replace(/\|\|shippingDiscount\|\|/g, shippingDiscountLine);
          this.wrapper.innerHTML += markup;

          // highlight the list with the discounted delivery
          document.querySelectorAll('#shipping-rates li').forEach(li => {
            const label = li.textContent.trim();
            if (label.includes('Limited Time Offer')) {
              li.style.backgroundColor = 'rgb(235, 206, 206)';
              li.style.fontWeight = '600';
            }
          });
          // end highlight

          this.wrapper.classList.remove(classes$D.hidden);
        }
      }

      enableButtons() {
        this.getRatesButton.removeAttribute('disabled');
        this.getRatesButton.classList.remove(classes$D.disabled);
        this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButton;
      }

      disableButtons() {
        this.getRatesButton.setAttribute('disabled', 'disabled');
        this.getRatesButton.classList.add(classes$D.disabled);
        this.getRatesButton.textContent = theme.strings.shippingCalcSubmitButtonDisabled;
      }

      getCartShippingRatesForDestination(shippingAddress) {
        const encodedShippingAddressData = encodeURI(
          getUrlString({
            shipping_address: shippingAddress,
          })
        );
        const url = `${theme.routes.cart_url}/shipping_rates.json?${encodedShippingAddressData}`;

        fetch(url)
          .then(this.handleErrors)
          .then((response) => response.text())
          .then((response) => {
            const responseJSON = JSON.parse(response);
            const rates = responseJSON.shipping_rates;
            this.onCartShippingRatesUpdate(rates, shippingAddress);
          })
          .catch((error) => {
            this.onError(error.json);
          });
      }

      fullMessagesFromErrors(errors) {
        const fullMessages = [];

        for (const error in errors) {
          for (const message of errors[error]) {
            fullMessages.push(message);
          }
        }

        return fullMessages;
      }

      handleErrors(response) {
        if (!response.ok) {
          return response.json().then(function (json) {
            const e = new FetchError({
              status: response.statusText,
              headers: response.headers,
              json: json,
            });
            throw e;
          });
        }
        return response;
      }

      onError(data) {
        this.enableButtons();
        let feedback = '';

        if (typeof this.spinnerDoneCallback === 'function') {
          this.spinnerDoneCallback();
          this.spinnerDoneCallback = null;
        }
        
        if (data.message) {
          feedback = data.message + '(' + data.status + '): ' + data.description;
        } else {
          feedback = texts.feedbackLabel + this.fullMessagesFromErrors(data).join('; ');
        }

        if (feedback === texts.error) {
          feedback = texts.feedback;
        }

        this.render({
          rates: [],
          errorFeedback: feedback,
          success: false,
        });
      }

      async onCartShippingRatesUpdate(rates, shippingAddress) {
        this.enableButtons();

        if (typeof this.spinnerDoneCallback === 'function') {
          this.spinnerDoneCallback();
          this.spinnerDoneCallback = null;
        }
  
        
        let readableAddress = '';
        if (shippingAddress.zip) {
          readableAddress += shippingAddress.zip + ', ';
        }
        let readableProvince = shippingAddress.province || '';
        if (readableProvince) {
          readableAddress += readableProvince + ', ';
        }

        readableAddress += shippingAddress.country;

        const selectedOption = this.selectProvince?.selectedOptions?.[0];
        const fullProvinceName = selectedOption?.textContent?.trim() || this.selectProvince?.dataset.defaultFullname || shippingAddress.province;

        saveShippingDataToLocalStorage(shippingAddress.province, fullProvinceName, shippingAddress.zip);

        // discount logic

        let discountLine = '';
        try{
          const cart = await getCartInfo();
          const cartTotal = cart.total_price / 100;
          const match = shippingDiscountData.find(entry => entry.state.toLowerCase() === fullProvinceName.toLowerCase() && entry.postcode === shippingAddress.zip);
          
          if (match && cartTotal < 1000){
            discountLine = `<ul id="shipping-discount"><li><p class="shipping-discount-msg info">Limited Time Offer - Get Discounted Delivery!<p>
                            <p>Spend $1000 or more and unlock exclusive shipping discounts! You're just $${1000-cartTotal} away from saving on delivery.</p></li></ul>`;
          }
        }catch(e){
          console.warn('Error checking discount info: ', e);
        }
        

        
        this.render({
          rates: rates,
          address: readableAddress,
          province: fullProvinceName,
          discountLine: discountLine,
          success: true,
        });
      }
    }

    if (!customElements.get('is-shipping-calculator')) {
      customElements.define('is-shipping-calculator', IsShippingCalculator);
    }
  
})(themeVendor.themeAddresses);